import * as React from 'react';

import styles from './case-report-info.scss';

interface CaseReportListingInformationProps {
  translation: any;
}

export const CaseReportListingInformation = React.memo(({
  translation
}: CaseReportListingInformationProps) => {
  return (
    <div className={styles.uiToggleInfo}>
      <div className={styles.title}>{translation.toggle_info_title}</div>
      <div className={styles.subTitle}>{translation.toggle_info_subtitle}</div>
      <div className={styles.description}>{translation.toggle_info_description}</div>
    </div>
  );
});
